module.exports = __webpack_public_path__ + "img/product11.be7a6682.png";